const PatientAdminFormValidation = {
  PATIENT: 'patient',
  CONTACT: 'contact',
  PATIENT_AND_CONTACT: 'patientAndContact',
};

export default PatientAdminFormValidation;
